import { createSelector } from '@reduxjs/toolkit';
import { userPropertiesForCurrentOrganization } from 'src/store/selectors';
import type { UiSettings } from './uiSettings';

export const uiSettings = createSelector([userPropertiesForCurrentOrganization], function (userProperties): UiSettings {
  return (
    userProperties.uiSettings || {
      isSimplifiedUi: false,
    }
  );
});
